export const ar = {
  language: "العربيه",
  home: {
    WelcometoTaarteb:"مرحبا Taarteb",
    Welcome:"مرحبا",
shipping:"سياسة الشحن",
pending:"قيد الانتظار",
orderProduct:"اذا واجهت صعوبه في الطلب .. يمكنك الطلب من خلال الواتس اب",

    Effortless: "تتبع حضور الطلاب بسهولة",
    Say: "قل وداعًا للحضور اليدوي والأوراق الرسمية. يساعد نظامنا الذكي المدارس على تتبع الحضور وإخطار أولياء الأمور على الفور وإنشاء تقارير مفيدة - كل ذلك في مكان واحد",
    GetStarted: "ابدأ الآن",
    QuickSummary: "ملخص سريع",
    Summary: "ملخص",
    TotalTeachers: "إجمالي المعلمين",
    TotalClasses: "إجمالي الفصول",
    TotalStudents: "إجمالي الطلاب",
    Verify:"تحقيق",
        VerifyProduct:"تحقيق المنتج",
Getintouch:"تواصل معنا",
    search:"بحث .......",
    WeeklyAttendanceReport: "تقرير الحضور الأسبوعي",
    
    AttendedAbsent: "حضور / غياب",
    
    Absent: "غائب",
    Attended: "حضور",
    TotalStudentsText: "إجمالي الطلاب",
products:"المنتجات",
CartEmpty:"عربة التسوق فارغة",
Wishlist:"المفصلة",
Subtotal:"السعر الفرعي",
discount:"خصم",
shipping:"شحن",
total:"المجموع",
checkout:"الدفع",

    price: "السعر",
    Quantity:"الكمية",
Notes:"الملاحظات",

TrackOrder:"تتبع الطلب",
OrderCode:"أدخل رمز طلبك لتتبع طلبك",
enter:"أدخل",

aboutus:"معلومات عنا",
aboutusFooter:"منتجات فاخرة للعناية بالجسم",
Shoppingcart:"عربة التسوق",
    "TodaysAttendance":"الحضور اليوم",
    "ManageYourSchoolsEfficiently":"إدارة مدارسك بكفاءة",
    "abouttitle": "لماذا تختار نظامنا؟",
    "aboutsubtitle": "نظامنا بسيط وفعال—فقط 3 خطوات سهلة",
    "feature1title": "تتبع الحضور التلقائي",
    "feature1description": "وداعًا لنداء الأسماء يدويًا! يمكن للمعلمين تسجيل الحضور بنقرة واحدة، وتسجيل الغيابات تلقائيًا.",
    "feature2title": "وصول متعدد المستخدمين وصلاحيات حسب الدور",
    "feature2description": "مصمم للمديرين والمعلمين، لضمان حصول الجميع على المستوى المناسب من الوصول إلى البيانات التي يحتاجونها.",
    "feature3title": "يعتمد على السحابة وآمن",
    "feature3description": "يمكن الوصول إلى النظام من أي مكان وعلى أي جهاز، مع تشفير البيانات بالكامل وتخزين سحابي آمن لحماية معلومات الطلاب.",
    "feature4title": "سياسات حضور قابلة للتخصيص",
    "feature4description": "يمكن للمدارس تحديد قواعد الحضور الخاصة بها، وسياسات التأخير، وحدود الغياب، مما يجعل النظام قابلاً للتكيف مع المؤسسات التعليمية المختلفة.",
    "howtitle": "كيف يعمل؟ دليل خطوة بخطوة",
    "howdescription": "نظامنا بسيط وفعال - فقط 3 خطوات سهلة",
    "step1Title": "تسجيل الدخول إلى النظام",
    "step1Description": "يقوم المعلمون والطلاب بتسجيل الدخول بأمان من أي جهاز.",
    "step2Title": "تحديد الحضور",
    "step2Description": "تتبع حضور الطلاب بسهولة بنقرة واحدة.",
    "step3Title": "الإشعارات والتقارير",
    "step3Description":
      "احصل على تحديثات فورية، وتوفر المدارس تقارير تفصيلية عن الحضور.",
    "contacttitle": "اتصل بنا",
    "contactsubtitle": "هل لديك أي استفسارات؟ فقط أرسل لنا رسالة!",
    "contactInfo": "معلومات الاتصال",
    "phone": "رقم الهاتف",
    "email": "البريد الإلكتروني",
    "ParentEmailAddress":"البريد الالكتروني لولي الامر",
    "Address":"العنوان",
    myAddresses:"عناويني",
    addNewAddress:"إضافة عنوان جديد",
    city:"المدينة",
    buildingNumber:"رقم المبني",
    seeOffer:"مشاهدة الاعلان",
        "deletesuccessMessage": "تم الحذف بنجاح!",
    "createorder": "تم أنشاء الطلب بنجاح.",

    house_number:"رقم الشقة",
    street:"الشارع",
    region:"المنطقة",
    Detailedaddress:"عنوان بالتفصيل",
    priceAfterDisc:"السعر بعد الخصم",
    "AddressValue":"الاسماعلية , مصر",
    Exchange:"سياسة الاستبدال والاسترجاع",
    privacy:"سياسة الخصوصية",
    "location": "١٥ شارع التحرير، وسط البلد، القاهرة، مصر، ١١٥١١",
    "namePlaceholder": "الاسم",
    "categories": "التصنيفات",
addtocart:"أضافة الي السلة",
    yoursecurity:"حدّث بياناتك ",
    UserProfile:"ملف تعريف المستخدم",
Personalinformation:"المعلومات الشخصية",
    "emailPlaceholder": "البريد الإلكتروني",
    "phonePlaceholder": "رقم الهاتف",
    "messagePlaceholder": "اكتب رسالتك...",
    "sendMessage": "إرسال الرسالة",
    "Loading": "جاري التحميل.........",
    "reachUs": "تواصل معنا",
    "quickLinks": "روابط سريعة",
    "home": "الرئيسية",
    "howItWorks": "كيف يعمل؟",
    "contactUs": "اتصل بنا",
    "whatsapp":"واتساب",
    "newsletterTitle": "انضم إلى نشرتنا الإخبارية",
    "newsletterPlaceholder": "عنوان بريدك الإلكتروني",
    "subscribe": "اشتراك",
    "newsletterNote": "* سنرسل لك تحديثات أسبوعية لإدارة الأدوات بشكل أفضل.",
    "features": "المميزات",
    "login": "تسجيل الدخول",
        ForgotPassword:"هل نسيت كلمة السر ؟",
        Recoverpassword:"استعادة كلمة المرور",
RememberyourpasswordRecoverpassword:"تذكرت كلمة المرور الخاصة بك استعادة كلمة المرور ؟",
resetPassword:"إعادة تعيين كلمة المرور",

    Createyouraccount:"أنشئ حسابك",
  Newcustomer:"عميل جديد ؟",
    "user": "المستخدم",
    "language": "العربية",
    "switchTo": "الإنجليزية",
    "welcome": "مرحبًا ، قم بتسجيل الدخول إلى حسابك",
    "subtitle": "إنه لمن دواعي سرورنا أن نرحب بكم!",
    "passwordPlaceholder": "كلمة المرور",
    Registration:"تسجيل",
    haveanaccount:"هل لديك حساب بالفعل؟",
    "ConfirmPassword": "تأكيد كلمة المرور",
    "loggingIn": "جاري تسجيل الدخول...",
    "fillFields": "يرجى ملء جميع الحقول",
    "invalidCredentials": "بيانات الاعتماد غير صالحة ، يرجى المحاولة مرة أخرى.",
    "successMessage": "تم تسجيل الدخول بنجاح!",
    "addsuccessMessage": "تم الأضافة بنجاح!",
        "ordersuccessMessage": "تم طلب الطلب بنجاح",

    "dashboard": "لوحة التحكم",
    "schools": "المدارس",
    "structure": "الهيكل المدرسي",
    "stages": "المراحل",
    "grades": "الصفوف",
    "grade": "الصف",

    "subjects": "المواد الدراسية",
    "subject": "المادة الدراسية",

    "teachers": "المعلمين",
    "teacher": "المعلم",

    "classes": "الفصول والجداول",
    "class": "الفصل",

    "addclass": "اضافة فصل",
    "ParentPhone": "رقم ولي الامر",

    "students": "الطلاب",
    "addStudents": "اضافة طالب",

    "attendanceHistory": "سجل الحضور",
    "markAttendance": "تسجيل الحضور",
    "profile": "الصفحة الشخصية",
    "changePassword": "تغيير كلمة المرور",
    "logout": "تسجيل الخروج",
    UpdateProfile:"تحديث الملف الشخصي",
logoutState:"هل أنت متأكد أنك تريد تسجيل الخروج؟",
    "export":"تحميل الملف",
    "schoolID":"رقم المدرسة",
    "addschools":"اضافة مدرسة",
    "Save":"حفظ",
    "SelectGender":"اختار النوع",
    "SelectClass":"اختار الفصل",
    "SelectTeacher":"اختار المعلم",
"Day":"اليوم",


    "SelectSubject":"اختار المادة الدراسية",

    "gender":"النوع",
    "male":"ذكر",
    "female":"أنثي",
    "Oldpassword":"كلمة المرور الحالية",
    "Newpassword":"كلمة المرور الجديدة",
    "Confirmpassword":"تأكيد كلمة المرور",
    "SchoolStracture":"هيكلة المدرسة",
    "addStage":"اضافة مرحلة",
    "add":"اضافة",
    "stageName":"اسم المرحلة",
    "gradeName":"اسم الصف",
    "ID":"رقم التسلسل",
    "AddGrades":"اضافة صف",
    "SelectStage":"اختار المرحلة",
    "addSubject":"اضافة مادة دراسية",
    "Semester":"الفصل الدراسي",
    "SelectGrades":"اختار الصف",
    "SelectSemester":"اختار الفصل الدراسي",
    
    "firstsemster":"الفصل الدراسي الاول",
    "secondsemester":"الفصل الدراسي الثاني",
"addteachers":"اضافة معلم",
"MaxStudents":"الحد الأقصى للطلاب",
"sessionnumber":"عدد الحصص",
"Session":"الحصة",
"SelectTimeTable":"قم بتحميل جدول الحصص",
"Selectday":"اختار اليوم",
"SelectSession":"اختار الحصة",
'monday': 'الاثنين',
'tuesday': 'الثلاثاء',
'wednesday': 'الأربعاء',
'thursday': 'الخميس',
'friday': 'الجمعة',
'saturday': 'السبت',
'sunday': 'الأحد',
"Selectyear":"اختار السنة الدراسية",
"status":"الحالة",
"settings":"الاعدادات",
"firstSection":"القسم الاول",
"secondSection":"القسم الثاني",
"thirdSection":"القسم الثالث",
title_ar: "العنوان بالعربية",
title_en: "العنوان بالانجليزية",

description_ar: "الوصف بالعربية",
description_en: "الوصف بالانجليزية",

image: "الصورة",
UploadMainImage:"تحميل الصورة الرئيسية",
ClickorDraganImage:"انقر أو اسحب صورة",
subtitle1_ar: "العنوان الفرعي 1 بالعربية",
subtitle_ar: "العنوان الفرعي بالعربية",

subtitle1_en: "العنوان الفرعي 1 بالانجليزية",
subtitle_en: "العنوان الفرعي بالانجليزية",



subtitle2_ar: "العنوان الفرعي 2 بالعربية",
subtitle2_en: "العنوان الفرعي 2 بالانجليزية",

subtitle3_ar: "العنوان الفرعي 3 بالعربية",
subtitle3_en: "العنوان الفرعي 3 بالانجليزية",


subtitle4_ar: "العنوان الفرعي 4 بالعربية",
subtitle4_en: "العنوان الفرعي 4 بالانجليزية",


subdescribtion1_ar: "الوصف الفرعي 1 بالعربية",
subdescribtion1_en: "الوصف الفرعي 1 بالانجليزية",
subdescribtion_en: "الوصف الفرعي  بالانجليزية",


subdescribtion2_ar: "الوصف الفرعي 2 بالعربية",
subdescribtion_ar: "الوصف الفرعي  بالعربية",

subdescribtion2_en: "الوصف الفرعي 2 بالانجليزية",


subdescribtion3_ar: "الوصف الفرعي 3 بالعربية",
subdescribtion3_en: "الوصف الفرعي 3 بالانجليزية",



describtion: "الوصف",
how_to_use_ar:"",
subdescribtion4_en: "الوصف الفرعي 4 بالانجليزية",
"TotalSchools":"أجمالي المدارس",
"notfountTitle":"لم يتم العثور على الصفحة",
"notfountParagraph1":"نأسف، لم يتم العثور على الصفحة المطلوبة",
"notfountParagraph2":"يرجى العودة إلى الصفحة الرئيسية",
"MarkAttendance":"تحصيل الغياب",
"areyousureyouwantdelet":"هل أنت متأكد أنك تريد حذف هذا؟",
"delete":"حذف",
"close":"غلق",
Default:"أفتراضي",
"edit":"تعديل",
Payment:"طرق الدفع",
Cash:"نقدا",
myOrder:"طلباتي",
order:"طلب",
trackingNumber:"رقم التتبع",
    details:"التفاصيل",
proccing:"يتم التجهيز",
shipped:"شحن",
delivered:"تم التسليم",
 Days:"أيام",

    orderdate:"تاريخ الطلب",
Estimateddelivery:"التسليم المتوقع",

"notmatch":"كلمة المرور الجديدة وكلمة المرور المؤكدة غير متطابقتين!",
"from":"من",
"to":"الي",
"chooseStageFirst":"الرجاء اختيار المرحلة اولا",
"chooseGradeandSemsterirst":"اختر الصف والفصل الدراسي أولاً",
"chooseGradefirst":"اختر الصف أولاً",
"deleteTimeTable":"حذف الجدول الدراسي",

"Generaldata":"General data",
Congratulations:"“مبروك! ✅ المنتج الخاص بك أصلي ومضمون من Heaven Smile.شكرًا لثقتك في منتجاتنا 💙.”",
Warning:"“تنبيه ⚠️ هذا الكود تم الاستعلام عنه مسبقًا.قد يكون أنت من قمت بالتحقق سابقًا، أو ربما استُخدم الكود في منتج مقلد .لو عندك أي استفسار تقدر تتواصل مع خدمة عملاء Heaven Smile.”",
InvalidcodeMsg:"“عذرًا ❌ الكود الذي أدخلته غير صحيح.هذا يعني أن المنتج غير أصلي أو تم تقليده.لضمان سلامتك، برجاء شراء منتجات Heaven Smile من الموزعين المعتمدين فقط.”",
description:"الوصف",
"howtouse":"كيفية الاستخدام",
"Benefitsofuse":"فوائد الاستخدام",
"activeIngredients":"المواد الفعالة",
terms:"الشروط و الأحكام",

enterCode:"أدخل كود المنتج",
goback:"العودة لادخال كود جديد",
"bestseller":"أفضل المنتجات",
"seeMore":"عرض المزيد",

},


};



